import getListings from '@api/routes/search-listings-api/getSearchListings';
import * as templates from './templates';
import push from '../../datalayer/utils/push';

if ($('[data-regon="searchListingResults"]').length > 0) {
    var Bunge = Bunge || {};

    Bunge.searchListings = (function($) {
        var ui = {};

        var searchParams = {
            pageNum: 1,
            searchTerm: '',
            pageSize: '8',
            sites: '',
        };

        let sitesType = $('[data-sites]').attr('data-sites');
        if (sitesType) {
            searchParams.sites = $('[data-sites]').attr('data-sites');
        }

        function cacheUI() {
            ui.$sortByDate = $('select[data-control="filter-main"]');
            ui.$sortByItemType = $(
                'select[data-control="filter-main-item-type"]'
            );
            ui.$includePdf = $('select[data-control="filter-main-pdf"]');
            ui.$filterYear = $('select[data-control="filter-main-year"]');
            ui.$listingRegon = $('[data-regon="searchListingResults"]');
            ui.$searchInput = $('[data-control="searchInput"]');
            ui.$searchSubmitBtn = $('[data-control="searchSubmit"]');
            ui.$searchWrapper = $('[data-regon="searchWrapper"]');
            ui.$pagination = $('[data-regon="pagination"]');
            ui.loader = $('[data-control="pageLoader"]');
            ui.$clearInput = $('[data-control="clearsearch"]');
            ui.$totalResults = $('[data-regon="totalResults"]');
            ui.$resultsFor = $('[data-regon="resultsFor"]');
            ui.$resultInfo = $('[data-regon="resultinfo"]');
            ui.totalpages = '';
            ui.totalResults = 0;
            ui.apiurl = ui.$listingRegon.data('apiurl');
        }

        let searchInput = document.querySelector(
            '[data-control="searchInput"]'
        );
        searchInput.addEventListener('keyup', function(e) {
            if (!ui.$searchInput.val() == '') {
                ui.$clearInput.show();
            } else {
                ui.$clearInput.hide();
            }
        });

        function bindEvents() {
            ui.$searchInput.on('keypress', function(e) {
                if (e.which == 13) {
                    searchClick();
                }
            });
            ui.$searchSubmitBtn.on('click', searchClick);
            ui.$clearInput.on('click', clearInput);
        }

        function init() {
            if ($('[data-regon="searchListingResults"]').length <= 0) {
                return;
            }
            cacheUI();
            bindEvents();
            showLoader();
            ui.$clearInput.hide();

            if (window.location.href.match(/\?./)) {
                const urlParams = new URLSearchParams(
                    decodeURIComponent(window.location.search)
                );

                for (const [key, value] of urlParams.entries()) {
                    searchParams[key] = value;

                    if (key === 'searchTerm' && value != '') {
                        ui.$searchInput.val(value);
                        ui.$clearInput.show();
                    }

                    if (key === 'sortByDate' && value != '') {
                        let items = document.querySelectorAll(
                            '[name="sortByDate"]'
                        );

                        items.forEach(function(item) {
                            if (item.value == value) {
                                item.checked = true;
                            } else {
                                item.checked = false;
                            }
                        });
                    }

                    if (key === 'includePdf' && value != '') {
                        let items = document.querySelectorAll(
                            '[name="includePdf"]'
                        );

                        items.forEach(function(item) {
                            if (item.value == value) {
                                item.checked = true;
                            } else {
                                item.checked = false;
                            }
                        });
                    }

                    if (key === 'sortByItemType' && value != '') {
                        let items = document.querySelectorAll(
                            '[name="sortByItemType"]'
                        );

                        items.forEach(function(item) {
                            if (item.value == value) {
                                item.checked = true;
                            } else {
                                item.checked = false;
                            }
                        });
                    }

                    if (key === 'filterYear' && value != '') {
                        let items = document.querySelectorAll(
                            '[name="filterYear"]'
                        );

                        items.forEach(function(item) {
                            if (item.value == value) {
                                item.checked = true;
                            } else {
                                item.checked = false;
                            }
                        });
                    }
                }
            }
            if (
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                    navigator.userAgent
                ) ||
                $(window).width() < 767
            ) {
                searchParams.pageSize = parseInt(
                    $('div[data-pageSizeMobile]').attr('data-pageSizeMobile')
                );
            } else {
                searchParams.pageSize = parseInt(
                    $('div[data-pageSize]').attr('data-pageSize')
                );
            }
            getSearchListings();
        }

        function updateFilterDropdown(value) {
            $(ui.$sortByDate)
                .find('option[value="' + value + '"]')
                .attr('selected', 'selected');
            $('#main-filter').val(value);
        }

        function updateResultInfo() {
            var info = '';
            if (searchParams.searchTerm !== '') {
                ui.$resultsFor.show();
                ui.$totalResults.hide();
                info += '&nbsp;' + searchParams.searchTerm;
            } else {
                ui.$totalResults.show();
                ui.$resultsFor.hide();
            }

            info += '&nbsp;' + ui.totalResults;
            ui.$resultInfo.html(info);
            ui.$resultInfo.show();
        }

        function searchClick() {
            showLoader();
            // Need to update event type accordingly 'searchEvent' or 'pressSearchEvent'
            push({'event': 'searchEvent', 'searchQuery': $('[data-search-page]').val()});
            searchParams.searchTerm = ui.$searchInput.val();
            searchParams.pageNum = 1;
            getSearchListings();
        }
        function clearInput() {
            ui.$searchInput.val('');
            ui.$clearInput.hide();
            ui.$searchInput.focus();
        }

        function scrollToTop() {
            let articleCardLink = document.querySelector('.search-card a');
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });

            setTimeout(function() {
                articleCardLink = document.querySelector('.search-card a');
                articleCardLink.focus();
            }, 500);
        }

        function paginationClick(e) {
            let selectedPage = $(e.currentTarget).data('page');
            showLoader();
            searchParams.pageNum = parseInt(selectedPage);
            getSearchListings();
            scrollToTop();
        }

        async function getSearchListings() {
            let url = ui.apiurl;
            if (process.env.NODE_ENV !== 'development') {
                getListings.setRoute(url);
            }
            const { success, data, error } = await getListings.query(
                searchParams
            );
            if (!success) {
                console.log('failed', error);
                hideLoader();
                return;
            }
            ui.totalpages = parseInt(data.totalPages);
            ui.totalResults = parseInt(data.totalResults);

            var searchCards = '';
            $.each(data.searchListings, function(i, item) {
                searchCards += `${templates.searchCard({
                    title: item.title,
                    date: item.date,
                    excerpt: item.excerpt,
                    linkURL: item.linkURL,
                })}`;
            });

            ui.$listingRegon.html(searchCards);
            updateResultInfo();
            updatePagination(searchParams.pageNum, ui.totalpages);
            updateURLHistory();
            hideLoader();
        }

        function updateURLHistory() {
            if ('URLSearchParams' in window) {
                var newSearchParams = new URLSearchParams(
                    window.location.search
                );
                newSearchParams.set('pageNum', searchParams.pageNum);
                if (searchParams.searchTerm.length > 0) {
                    newSearchParams.set('searchTerm', searchParams.searchTerm);
                }

                newSearchParams.set('sites', searchParams.sites);

                if (searchParams.sortByDate) {
                    newSearchParams.set('sortByDate', searchParams.sortByDate);
                }

                if (searchParams.sortByItemType) {
                    newSearchParams.set(
                        'sortByItemType',
                        searchParams.sortByItemType
                    );
                }

                if (searchParams.includePdf) {
                    newSearchParams.set('includePdf', searchParams.includePdf);
                } else {
                    newSearchParams.delete('includePdf');
                }

                if (searchParams.filterYear) {
                    newSearchParams.set('filterYear', searchParams.filterYear);
                } else {
                    newSearchParams.delete('filterYear');
                }

                var newRelativePathQuery =
                    window.location.pathname + '?' + newSearchParams.toString();
                history.pushState(null, '', newRelativePathQuery);
            }
        }

        function listingFilterToggle(e) {
            let currentDropdown = e.currentTarget.nextElementSibling;

            if ($(currentDropdown).hasClass('-hidden')) {
                $('.listing__filter__dropdown__container').addClass('-hidden');
                $('.listing__filter__toggle-button').removeClass('active');
                $(currentDropdown).removeClass('-hidden');
                $(this).addClass('active');
            } else {
                $('.listing__filter__dropdown__container').addClass('-hidden');
                $('.listing__filter__toggle-button').removeClass('active');
            }
        }

        $('.listing__filter__toggle-button').on('click', listingFilterToggle);

        function radioClick(e) {
            let currentDropdown = e.currentTarget;
            let name = currentDropdown.name;
            if (name == 'sortByDate') {
                searchParams.sortByDate = $(this).val();
            }

            if (name == 'sortByItemType') {
                searchParams.sortByItemType = $(this).val();
            }

            if (name == 'includePdf') {
                searchParams.includePdf = $(this).val();
            }

            if (name == 'filterYear') {
                searchParams.filterYear = $(this).val();
            }
            searchParams.pageNum = 1;
            // Need to update event type accordingly 'searchEvent' or 'pressSearchEvent'
            push({'event': 'searchEvent', 'facetsList': searchParams});
            getSearchListings();
            updateURLHistory();

            $('.listing__filter__toggle-button.active').click();

            let ymenuButton = $('.js-toggle-year-menu.active-button');
            if (ymenuButton.length > 0) {
                ymenuButton.click();
            }
            let pdfMenuButton = $('.js-toggle-pdf-menu.active-button');
            if (pdfMenuButton.length > 0) {
                pdfMenuButton.click();
            }
        }

        $('.listing__filter__dropdown__item input').on('click', radioClick);

        function toggleYearMenu() {
            $('.by-year').toggle();
            $('.by-pdf').hide();
            if ($(this).hasClass('active-button')) {
                $('.active-button').removeClass('active-button');
            } else {
                $('.active-button').removeClass('active-button');
                $(this).addClass('active-button');
            }
        }

        $('.js-toggle-year-menu').on('click', toggleYearMenu);

        function togglePdfMenu() {
            $('.by-pdf').toggle();
            $('.by-year').hide();
            if ($(this).hasClass('active-button')) {
                $('.active-button').removeClass('active-button');
            } else {
                $('.active-button').removeClass('active-button');
                $(this).addClass('active-button');
            }
        }

        $('.js-toggle-pdf-menu').on('click', togglePdfMenu);

        function resetFilters() {
            $('.by-pdf').hide();
            $('.by-year').hide();
            $('.active-button').removeClass('active-button');
            searchParams.includePdf = '';
            searchParams.filterYear = '';
            searchParams.pageNum = 1;
            let sideMenuRb = document.querySelectorAll(
                '.listing__filter__dropdown__side-menu__buttons input'
            );
            sideMenuRb.forEach(function(item) {
                item.checked = false;
            });
            getSearchListings();
            updateURLHistory();
            $('.listing__filter__toggle-button.active').click();
        }

        $('.js-reset-filters').on('click', resetFilters);

        function updatePagination(page, totalPages) {
            let liTag = '';
            let active = '';
            page = parseInt(page);
            let beforePage = page - 1;
            let afterPage = page + 1;

            if (page > 1) {
                liTag += `<li class="page-item"><button data-page="${page -
                    1}" class="page-link" aria-label="Previous"><span aria-hidden="true"></span></button></li>`;
            } else if (page == 1) {
                liTag += `<li class="page-item disabled"><button data-page="${page}" class="page-link" disabled="true" aria-label="Previous"><span aria-hidden="true"></span></button></li>`;
            }

            if (page > 2) {
                if (totalPages >= 5) {
                    liTag += `<li class="page-item"><button data-page="1" class="page-link"><span>1</span></button></li>`;
                }
                if (page > 3 && totalPages > 5) {
                    liTag += `<li class="page-item pagination-bar__dots dots"><span class="page-link">...</span></li>`;
                }
            }
            // how many pages or li show before the current li
            if (page == totalPages) {
                beforePage = beforePage - 2;
            } else if (page == totalPages - 1) {
                beforePage = beforePage - 1;
            }

            if (beforePage < 0) {
                beforePage = 0;
            }
            // how many pages or li show after the current li
            if (page == 1) {
                afterPage = afterPage + 2;
            } else if (page == 2) {
                afterPage = afterPage + 1;
            }
            for (let plength = beforePage; plength <= afterPage; plength++) {
                if (plength > totalPages) {
                    //if plength is greater than totalPage length then continue
                    continue;
                }
                if (plength == 0) {
                    //if plength is 0 than add +1 in plength value
                    plength = plength + 1;
                }
                if (page == plength) {
                    //if page is equal to plength than assign active string in the active variable
                    active = 'active';
                } else {
                    //else leave empty to the active variable
                    active = '';
                }
                liTag += `<li class="page-item numb ${active}"><button data-page="${plength}" class="page-link"><span>${plength}</span></button></li>`;
            }

            if (page < totalPages - 1) {
                //if page value is less than totalPage value by -1 then show the last li or page
                if (page < totalPages - 2 && totalPages > 5) {
                    //if page value is less than totalPage value by -2 then add this (...) before the last li or page
                    liTag += `<li class="page-item dots"><span class="page-link">...</span></li>`;
                }
                if (totalPages >= 5) {
                    liTag += `<li class="page-item last numb"><button  data-page="${totalPages}" class="page-link"><span>${totalPages}</span></button></li>`;
                }
            }

            if (page <= totalPages) {
                //show the next button if the page value is less than totalPage
                if (page < totalPages) {
                    liTag += `<li class="page-item" ><button data-page="${page +
                        1}" class="page-link" aria-label="Next"><span aria-hidden="true"></span></button></li>`;
                } else if (page == totalPages) {
                    liTag += `<li class="page-item disabled"><button data-page="${page}" class="page-link" disabled="true" aria-label="Next"><span aria-hidden="true"></span></button></li>`;
                }
            }
            ui.$pagination.html(liTag); //add li tag inside ul tag
            $('.pagination .page-link').each(function() {
                $(this).on('click', paginationClick);
            });
        }

        function showLoader() {
            ui.$searchWrapper
                .css('opacity', '.3')
                .css('pointer-events', 'none');
            ui.loader.show();
        }

        function hideLoader() {
            ui.$searchWrapper.css('opacity', '1').css('pointer-events', 'all');
            ui.loader.hide();
        }

        updateFilterDropdown(searchParams.sortByDate);

        return {
            init: init,
        };
    })(jQuery);

    $(function() {
        Bunge.searchListings.init();
    });
}
